import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-travel-reason',
  templateUrl: './travel-reason.component.html',
  styleUrls: ['./travel-reason.component.scss']
})
export class TravelReasonComponent implements OnInit {

  @Input() data: any;
  status = {
    1: ['First Approval'],
    2: ['Second Approval'],
    3:['Approved'],
    4:['Rejected'],
    5:['Cancelled'],
    6:['Pushed back']
  };
  label: string;
  name: string;
  datelabel: any;
  secondlabel: any;
  secondName: any;
  Seconddatelabel: any;
  reason: any;

  constructor() { }

  ngOnInit() {

    if (this.data.status_id == 2 || this.data.status_id == 3 || this.data.status_id == 4 || this.data.status_id == 5 ) {
      this.label = this.status[this.data.status_id][0];
    }
   
    if (this.data.status_id == 2 || this.data.status_id == 3 || this.data.status_id == 101) {
      if (this.data.first_approved_by) {
        this.name = this.data.first_approved_by_user.name;
        this.datelabel = this.data.first_approved_by_user.updated_at;
        this.label = this.status[1][0];
      }
  
      if (this.data.second_approved_by) {
        this.secondlabel = this.status[2][0];
        this.secondName = this.data.second_approved_by_user.name;
        this.Seconddatelabel = this.data.second_approved_by_user.updated_at;
      }
    }

    if (this.data.status_id == 4) {
      if (this.data.first_rejected_by) {
        this.name = this.data.first_rejected_by_user.name;
        this.datelabel = this.data.first_rejected_by_user.updated_at;
        if (this.data.travel_reason) {
          if (this.data.travel_reason.performed_by == this.data.first_rejected_by_user.id) {
            this.reason = this.data.travel_reason.reason;
          }
        }
      }

      if (this.data.second_rejected_by) {
        this.secondName = this.data.second_rejected_by_user.name;
        this.Seconddatelabel = this.data.second_rejected_by_user.updated_at;
        this.secondlabel = this.status[4][0];

        if (this.data.travel_reason) {
          if (this.data.travel_reason.performed_by == this.data.second_rejected_by_user.id) {
            this.reason = this.data.travel_reason.reason;
          }
        }
      }
    }

    if (this.data.status_id == 5) {
      if (this.data.cancelled_by_user) {
        this.name = this.data.cancelled_by_user.name;
        this.datelabel = this.data.cancelled_at;
        this.reason = this.data.travel_reason ? this.data.travel_reason.reason : '';
      }
    }

  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }


}
